class DownlistModalController {
  constructor (InfringementAPI, $typeMap) {
    'ngInject';
    
    this.typeMap = $typeMap
    this.typeTextObject={//转载报告
      article: "文章",
      in_one_article: "文章",
      in_one_site: "网站",
      normal: "时间",
      site: "网站"
    }

    this.excels = {
      data: [],
      pageCount: 1,
      page: 1,
      enable: false,
      firstPageData: [],
      loadPage:(page) => {
        this.excels.page = page
        InfringementAPI.one('reports').get({
          page: page,
          page_size:5
        })
          .then(res => {
            if (page === 1) {
              this.excels.firstPageData = res.data.data
            }
            if (res.data.data.length) {
              this.excels.enable = true
            }
            this.excels.data = res.data.data
            this.excels.pageCount = res.data.last_page
          })
          .catch(e => {
            console.log(e)
          })
      }
    }

  }
  $onInit() {
    this.excels.loadPage(1)
  }

  downloadExcel(download) {
    if (download) {
      window.open(download)
    }
  }
  
  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default DownlistModalController


// WEBPACK FOOTER //
// ./src/app/common/downlist-modal/downlist-modal.controller.js